import { IdLabel } from "../../../components/IdLabel/index.js";
import { useRecord } from "../hooks/useRecord.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Records/shared/RecordTitle.tsx
function RecordTitle({ id, showId }) {
	const { data } = useRecord({ recordId: id || "" }, {
		cacheStrategy: "cache-only",
		fire: !!id
	});
	if (data?.record) return /* @__PURE__ */ jsxs("span", { children: [data.record.title, showId && /* @__PURE__ */ jsxs(Fragment$1, { children: [" ", /* @__PURE__ */ jsx(IdLabel, {
		className: "text-color-subtle font-medium",
		idLabel: data.record.idLabel
	})] })] });
	return null;
}
//#endregion
export { RecordTitle };

//# sourceMappingURL=RecordTitle.js.map